import React, { useState, createContext } from 'react';

export const AuthUserContext = createContext({});

export const AuthUserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [roomData, setRoomData] = useState(null);
  const [userBlock, setUserBlock] = useState(false);

  return (
    <AuthUserContext.Provider value={{ user, setUser, profile, setProfile, roomId, setRoomId,roomData, setRoomData, userBlock, setUserBlock}}>
      {children}
    </AuthUserContext.Provider>
  );
};